import { lazy } from 'react';

export const CalendarAsync = lazy(() => import('./calendar.component'));
